const furnitureTypeCatalog = () => {
    const $container = $('.js-furniture-type-catalog');

    if($container.length > 0) {
        let button = $container.find('.js-expand-button');
        let items_gt = $container.find('.js-furniture-type-catalog-box:gt(5)');
        items_gt.wrapAll('<div style="display:none; width: 100%;" class="row js-hidden-items"></div>');

        button.on('click', function() {
            $container.find('.js-hidden-items').slideDown();
            button.hide();
        });
    }

};

export default furnitureTypeCatalog;